import { render, staticRenderFns } from "./SeasonCommonScore.vue?vue&type=template&id=7a994858&scoped=true&"
import script from "./SeasonCommonScore.vue?vue&type=script&lang=js&"
export * from "./SeasonCommonScore.vue?vue&type=script&lang=js&"
import style0 from "./SeasonCommonScore.vue?vue&type=style&index=0&id=7a994858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a994858",
  null
  
)

export default component.exports